<template>
  <div class="gap-4">
    <FGroup label="Telegram Bot">
      <a :href="`https://t.me/saraf_robot?start=${user?.id}`" target="_blank">
        <CButton
          :text="$t('activate_telegram_bot')"
          size="sm"
          class="w-max"
          icon="icon-telegram text-xl text-white"
          icon-position="left"
        />
      </a>
    </FGroup>
    <TelegramProfiles
      :users="telegramUsers"
      @handleDeleteTelegramUser="deleteTelegramUser"
    />
  </div>
</template>

<script setup lang="ts">
import TelegramProfiles from "@/modules/Profile/components/TelegramProfiles.vue";
import FGroup from "@/components/Form/FGroup.vue";
import CButton from "@/components/Common/CButton.vue";
import ApiService from "@/services/ApiService";
import { computed, onMounted, ref } from "vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { useCustomToast } from "@/composables/useCustomToast";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { showToast } = useCustomToast();

const telegramUsers = ref([]);
const authStore = useAuthStore();

const user = computed(() => authStore?.user);

const getTelegramUsers = () => {
  ApiService.get("user/telegram-user/").then((res) => {
    telegramUsers.value = res?.data?.results;
  });
};

const deleteTelegramUser = (id: number) => {
  ApiService.delete(`user/telegram-user/${id}/delete/`)
    .then((res) => {
      if (res) {
        telegramUsers.value = telegramUsers.value.filter((el) => el?.id !== id);
        showToast(t("telegram_account_unsubscribed"), "success");
        getTelegramUsers();
      }
    })
    .catch((err) => {
      if (err?.response?.status === 500) {
        showToast(t("error_status_500"), "error");
      }
    });
};
onMounted(() => {
  getTelegramUsers();
});
</script>

<style scoped></style>
